import { IInfrastructureType } from '../../../common/types/infrastructure';
import { IMapState } from '../../types';

export function selectActiveType(state: IMapState): IInfrastructureType | undefined {
  if (!state.map.infrastructure.activeType) {
    return;
  }

  return state.map.infrastructure.types[state.map.infrastructure.activeType];
}
